module.exports = __webpack_public_path__ + "img/auth-助考之星-山河医学网授权书.b7776261.jpg";